import '../style/favorite-CfDkkLdg.css'
import { defineComponent as f, useCssVars as g, useModel as C, computed as r, openBlock as k, createElementBlock as V, normalizeClass as _, unref as s, withModifiers as i, withKeys as b, createVNode as w, normalizeProps as z, guardReactiveProps as F, createBlock as $, mergeProps as B } from "vue";
import y from "./icon.js";
import { UPDATE_MODEL_VALUE as x } from "./constant/events.js";
const P = ["aria-checked"], K = /* @__PURE__ */ f({
  name: "e-favorite",
  __name: "favorite",
  props: {
    modelValue: { type: Boolean, default: !1 },
    name: {},
    size: { default: 24 },
    inactiveColor: {},
    activeColor: {},
    color: { default: "var(--text-decorative-yellow)" },
    icon: {},
    svg: {}
  },
  emits: ["toggle", x],
  setup(c, { emit: v }) {
    g((t) => ({
      "3257d88c": n.value,
      "6936f27f": m.value
    }));
    const e = c, u = v, o = C(e, "modelValue", { local: !0 }), n = r(() => e.inactiveColor ?? e.color), m = r(() => e.activeColor ?? e.color), p = r(() => [
      "e-favorite",
      {
        on: o.value
      }
    ]), l = (t) => {
      o.value = !o.value, u("toggle", {
        value: o.value,
        name: t
      });
    };
    return (t, a) => (k(), V("span", {
      class: _(p.value),
      "aria-label": "Favorite",
      role: "checkbox",
      tabindex: "0",
      "aria-checked": s(o),
      onClick: a[0] || (a[0] = i((d) => l(t.name), ["stop", "prevent"])),
      onKeydown: a[1] || (a[1] = b(i((d) => l(t.name), ["stop", "prevent"]), ["space", "enter"]))
    }, [
      w(s(y), z(F(e)), null, 16)
    ], 42, P));
  }
}), M = /* @__PURE__ */ f({
  name: "e-star",
  __name: "star",
  props: {
    modelValue: { type: Boolean, default: !1 },
    name: {},
    size: { default: 24 },
    inactiveColor: { default: "var(--text-tertiary)" },
    activeColor: { default: "var(--text-decorative-yellow)" },
    color: {},
    icon: { default: "star-fill" },
    svg: {}
  },
  emits: ["toggle", x],
  setup(c, { emit: v }) {
    g((t) => ({
      "71a67b56": t.inactiveColor,
      "0576911b": n.value
    }));
    const e = c, u = v, o = C(e, "modelValue", { local: !0 }), n = r(() => e.activeColor ?? e.color), m = r(() => ({
      size: e.size,
      icon: e.icon,
      color: o.value ? n.value : "transparent"
    })), p = r(() => [
      "e-star",
      {
        on: o.value
      }
    ]), l = (t) => {
      o.value = !o.value, u("toggle", {
        value: o.value,
        name: t
      });
    };
    return (t, a) => (k(), $(s(y), B({ class: p.value }, m.value, {
      "aria-label": "Favorite",
      role: "checkbox",
      tabindex: "0",
      "aria-checked": s(o),
      onClick: a[0] || (a[0] = i((d) => l(t.name), ["stop", "prevent"])),
      onKeydown: a[1] || (a[1] = b(i((d) => l(t.name), ["stop", "prevent"]), ["space", "enter"]))
    }), null, 16, ["class", "aria-checked"]));
  }
});
export {
  M as Star,
  K as default
};
//# sourceMappingURL=favorite.js.map
